import { post, postJson, get } from './axios'


const RESOURCE_BASE_PATH = '/members-api';

/*
 * 获取积分变更明细列表
 * */
export const getScoresCardList = p => postJson(`${RESOURCE_BASE_PATH}/scoresCard/list`, p);
// export const getScoresCardList = p => post(`${RESOURCE_BASE_PATH}/scoresCard/list`, p);


/*
 * 获取积分变更明细列表
 * */
export const getMyList = p => postJson(`${RESOURCE_BASE_PATH}/bindAuthController/myList`, p);

/*
 * 开启/关闭会员体系
 * */
export const scoresCardFlag = p => get(`${RESOURCE_BASE_PATH}/scoresCard/flag`, p);
